import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren  } from '@angular/core';

@Component({
  selector: 'app-set-cells-value',
  templateUrl: './set-cells-value.component.html',
  styleUrls: ['./set-cells-value.component.css']
})
export class SetCellsValueComponent implements OnInit, AfterViewInit {
    @ViewChildren('input') vc;
    cellValue: number = null;

  constructor() { }

  @Input() x = 0;
  @Input() y = 0;
  @Output() setValueCloseEvent = new EventEmitter<string>();
  @Output() setValueEvent = new EventEmitter<number>();

  ngOnInit() {
  }

  ngAfterViewInit() {
      setTimeout(() => { this.vc.first.nativeElement.focus() });
  }

  closeClicked() {
      this.setValueCloseEvent.emit('Close');
  }

  setClicked() {
      this.setValueEvent.emit(this.cellValue);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/set-cells-value/set-cells-value.component.ts